import React from "react";

const HeaderSubMenuItemSpan = ({span}) => {
    return (
        <span className="bg-[#f97066] text-white text-[14px] rounded-[20px] px-[6px]">
            {span}
        </span> 
    );
}

export default HeaderSubMenuItemSpan;